import React, { Component } from 'react';
import { connect } from 'react-redux';
import { orderAction } from '../actions/orderAction';
import { Row, Col, Form, Button } from 'react-bootstrap';
import moment from 'moment';

function getDefaultDateRange() {
  const now = new Date();
  const firstDayPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastDayPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);
  const pad = n => n < 10 ? '0' + n : n;
  const startDate = `${firstDayPrevMonth.getFullYear()}-${pad(firstDayPrevMonth.getMonth() + 1)}-${pad(firstDayPrevMonth.getDate())}`;
  const endDate = `${lastDayPrevMonth.getFullYear()}-${pad(lastDayPrevMonth.getMonth() + 1)}-${pad(lastDayPrevMonth.getDate())}`;
  return { startDate, endDate };
}

const datePresets = [
  { value: 'today', label: 'Hôm nay' },
  { value: 'yesterday', label: 'Hôm qua' },
  { value: 'this_week', label: 'Tuần này' },
  { value: 'last_week', label: 'Tuần trước' },
  { value: 'this_month', label: 'Tháng này' },
  { value: 'last_month', label: 'Tháng trước' },
  { value: 'all', label: 'Tất cả' }
];

function getDateRangeByPreset(preset) {
  const today = moment().startOf('day');
  let from = '', to = '';
  switch (preset) {
    case 'today':
      from = today.format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
      break;
    case 'yesterday':
      from = today.clone().subtract(1, 'days').format('YYYY-MM-DD');
      to = from;
      break;
    case 'this_week':
      from = today.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD'); // Monday
      to = today.format('YYYY-MM-DD');
      break;
    case 'last_week':
      from = today.clone().subtract(1, 'weeks').startOf('week').add(1, 'days').format('YYYY-MM-DD');
      to = today.clone().subtract(1, 'weeks').endOf('week').add(1, 'days').format('YYYY-MM-DD');
      break;
    case 'this_month':
      from = today.clone().startOf('month').format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
      break;
    case 'last_month':
      from = today.clone().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      to = today.clone().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      break;
    case 'all':
      from = '';
      to = '';
      break;
    default:
      from = today.format('YYYY-MM-DD');
      to = today.format('YYYY-MM-DD');
  }
  return { startDate: from, endDate: to };
}

class SaleTeamStats extends Component {
  constructor(props) {
    super(props);
    const { startDate, endDate } = getDefaultDateRange();
    this.state = {
      startDate,
      endDate,
      datePreset: 'last_month'
    };
  }

  componentDidMount() {
    this.fetchStats();
  }

  fetchStats = () => {
    const { startDate, endDate } = this.state;
    this.props.getSaleTeamStatus({ startDate, endDate });
  };

  handleStartDateChange = (e) => {
    this.setState({ startDate: e.target.value, datePreset: '' });
  };

  handleEndDateChange = (e) => {
    this.setState({ endDate: e.target.value, datePreset: '' });
  };

  handlePresetChange = (e) => {
    const preset = e.target.value;
    const { startDate, endDate } = getDateRangeByPreset(preset);
    this.setState({ datePreset: preset, startDate, endDate }, this.fetchStats);
  };

  render() {
    const { saleTeamStats, loading, error } = this.props;
    const { startDate, endDate, datePreset } = this.state;
    return (
      <div className="container mt-4">
        <h2>Thống kê Team Sale</h2>
        <Form className="mb-3">
          <Row className="align-items-end">
            <Col md={3}>
              <Form.Group>
                <Form.Label>Chọn khoảng thời gian</Form.Label>
                <Form.Select value={datePreset} onChange={this.handlePresetChange}>
                  <option value="">-- Tuỳ chọn --</option>
                  {datePresets.map(p => (
                    <option key={p.value} value={p.value}>{p.label}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Từ ngày</Form.Label>
                <Form.Control type="date" value={startDate} onChange={this.handleStartDateChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label>Đến ngày</Form.Label>
                <Form.Control type="date" value={endDate} onChange={this.handleEndDateChange} />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Button variant="primary" onClick={this.fetchStats} style={{ width: '100%' }}>Lấy thống kê</Button>
            </Col>
          </Row>
        </Form>
        {loading && <div>Đang tải...</div>}
        {error && <div style={{ color: 'red' }}>{error.toString()}</div>}
        {saleTeamStats && (
          <>
            <div className="d-flex flex-wrap gap-3 mb-4" style={{ justifyContent: 'flex-start' }}>
              <div style={{ minWidth: 160, background: '#f5f6fa', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px #eee', textAlign: 'center' }}>
                <div style={{ fontWeight: 600, color: '#636e72' }}>Tổng đơn</div>
                <div style={{ fontSize: 24, fontWeight: 'bold', color: '#0984e3' }}>{(saleTeamStats.totalValidOrders || 0) + (saleTeamStats.cancelOrders || 0)}</div>
              </div>
              <div style={{ minWidth: 160, background: '#f5f6fa', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px #eee', textAlign: 'center' }}>
                <div style={{ fontWeight: 600, color: '#636e72' }}>Đơn huỷ</div>
                <div style={{ fontSize: 24, fontWeight: 'bold', color: '#d63031' }}>{saleTeamStats.cancelOrders || 0}</div>
              </div>
              <div style={{ minWidth: 160, background: '#f5f6fa', borderRadius: 8, padding: 16, boxShadow: '0 1px 4px #eee', textAlign: 'center' }}>
                <div style={{ fontWeight: 600, color: '#636e72' }}>Đơn thực tế</div>
                <div style={{ fontSize: 24, fontWeight: 'bold', color: '#00b894' }}>{saleTeamStats.totalValidOrders || 0}</div>
              </div>
            </div>
            <h5 className="mt-4 mb-2">Thưởng KPI</h5>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Loại</th>
                  <th>Số lượng</th>
                  <th>Mức thưởng</th>
                  <th>Thưởng</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Đơn đèn (ít nhất 1 đèn)</td>
                  <td>{saleTeamStats.lampOrders}</td>
                  <td>10.000đ</td>
                  <td>{(saleTeamStats.lampOrders * 10000).toLocaleString()}đ</td>
                </tr>
                <tr>
                  <td>Đơn hộp lẻ (không có đèn nhưng có hộp)</td>
                  <td>{saleTeamStats.boxOrders}</td>
                  <td>10.000đ</td>
                  <td>{(saleTeamStats.boxOrders * 10000).toLocaleString()}đ</td>
                </tr>
                <tr>
                  <td>Đèn thứ 2 trở đi</td>
                  <td>{saleTeamStats.lampExtraCount}</td>
                  <td>5.000đ</td>
                  <td>{(saleTeamStats.lampExtraCount * 5000).toLocaleString()}đ</td>
                </tr>
                <tr>
                  <td>Đơn MH (listing mô hình)</td>
                  <td>{saleTeamStats.modelListingCount}</td>
                  <td>3.000đ</td>
                  <td>{(saleTeamStats.modelListingCount * 3000).toLocaleString()}đ</td>
                </tr>
                <tr style={{ fontWeight: 'bold', background: '#f5f5f5' }}>
                  <td colSpan={3} style={{ textAlign: 'right' }}><b>Tổng thưởng</b></td>
                  <td style={{ fontWeight: 'bold', fontSize: '1.2em', color: '#d35400' }}>{(
                    saleTeamStats.lampOrders * 10000 +
                    saleTeamStats.boxOrders * 10000 +
                    saleTeamStats.lampExtraCount * 5000 +
                    saleTeamStats.modelListingCount * 3000
                  ).toLocaleString()}đ</td>
                </tr>
              </tbody>
            </table>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  saleTeamStats: state.orderReducer.saleTeamStats,
  loading: state.orderReducer.loading,
  error: state.orderReducer.error
});

export default connect(mapStateToProps, {
  getSaleTeamStatus: orderAction.getSaleTeamStatus
})(SaleTeamStats); 